import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { DateInput } from 'shouldve-been-mui';

class DateChecklistElement extends ChecklistElement {

    private _currentAsDefault: boolean;
    
    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, currentAsDefault: boolean) {

        super(elementId, name, itemNumber, sortNumber, EditorType.DATE);
        this._currentAsDefault = currentAsDefault;
    }

    public get currentAsDefault(): boolean {
        return this._currentAsDefault;
    }

    public set currentAsDefault(value: boolean) {
        this._currentAsDefault = value;
    }

    public buildFormElement(value: Date | null, onChange: (value: Date | null) => Promise<void>, screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <DateInput
                    value={value}
                    onChange={onChange}
                    minWidth={Math.min(screenWidth * 0.8, 500)}
                    maxWidth={Math.min(screenWidth * 0.8, 500)}
                    dense={true}
                    labelText={this.name}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default DateChecklistElement;